module.exports = __webpack_public_path__ + "img/tapak-semaian-kelapa-sawit-bt-19.300b6e64.jpeg";